module.exports = __webpack_public_path__ + "img/step.305e06b6.png";